// START GENAI@CHATGPT4
const isValidRequestedNetwork = (cardBrand: string, networks: Array<string>) => {
  return networks.includes(cardBrand);
};
// END GENAI@CHATGPT4

export default isValidRequestedNetwork;
